import { cn } from "@/utils/theme";
import { Button, Icon, Input } from "@elaniintc/goes-design-system";
import { useMemo, useState } from "react";
import { VariableSelector } from "./VariableSelector";
import type { NodeVariable } from "../../types";
import { useResolution } from "../context";

interface ResolutionCommentProps {
  variables: NodeVariable[];
}
export const ResolutionComment = ({ variables }: ResolutionCommentProps) => {
  const [error] = useState<string>("");
  const {
    commentVariable,
    setCommentVariable,
    commentValue,
    setCommentValue,
    commentIsVariable,
    setCommentIsVariable,
  } = useResolution();

  const cleanUpComment = (isVariable: boolean) => {
    if (isVariable) {
      setCommentValue("");
    } else {
      setCommentVariable(null);
    }
  };

  const filteredVariables = useMemo(
    () =>
      variables
        .map((v) => {
          return {
            ...v,
            variables: (v.variables ?? []).filter(({ type }) => {
              return type === "string";
            }),
          };
        })
        .filter(({ variables }) => {
          return variables.length > 0;
        }),
    [variables],
  );

  return (
    <div className="flex flex-col gap-1">
      <div className="w-full flex justify-between">
        <label
          className={cn("font-semibold text-body-loud text-sm leading-2xl")}
          htmlFor="resolution-comment"
        >
          Comentario de resolución
        </label>
        <span className="text-body-quiet text-sm leading-2xl">Opcional</span>
      </div>
      <div className="flex h-11 w-full">
        <Button
          group="left"
          variant="quiet"
          type="button"
          className="font-mono h-full"
          data-testid="toggle-comparative-value-type-btn"
          onClick={() => {
            setCommentIsVariable(!commentIsVariable);
            cleanUpComment(!commentIsVariable);
          }}
        >
          {commentIsVariable ? "var" : "inp"}
        </Button>
        {commentIsVariable ? (
          <VariableSelector
            className="flex-auto"
            triggerGroup="right"
            variables={filteredVariables}
            selectedVariable={commentVariable}
            onSelectVariable={(variable) =>
              setCommentVariable(variable || null)
            }
          />
        ) : (
          <div className="relative w-full">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Icon type="far" name="text" className="text-body" />
            </div>
            <Input
              group="right"
              id="resolution-comment"
              name="resolution-comment"
              className="w-full pl-9 h-full"
              placeholder="Escribe un comentario"
              max={255}
              maxLength={255}
              value={commentValue}
              onChange={(e) => setCommentValue(e.target.value)}
            />
          </div>
        )}
      </div>

      {error && (
        <div className="text-danger flex items-center gap-1.5">
          <span className="text-current text-xs leading-xl font-normal">
            {error}
          </span>
        </div>
      )}
    </div>
  );
};
